export default {"src":"/_next/static/media/grundriss-modern.a1a5d750.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};